export default __webpack_public_path__ + "static/media/individual.9cb1e737.webp";